import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @export
 *
 * This component will be used to add a label to a widget to show that it's being rendered using sample data
 *
 * @example
 *
 * ```
 * <SampleDataLabel
 *  show={true}
 * />
 * ```
 *
 * @advanced
 */
const SampleDataLabel = ({ show = false }) => {
    if (!show)
        return null;
    return (_jsx("div", { className: "uxpcore_sampledata", children: _jsx("div", { className: "uxpcore_sampledata__ribbon", children: "Sample Data" }) }));
};
export default SampleDataLabel;
